import { createContext, useContext } from 'react';

/**
 * Route prefix for the authed app shell.
 *
 * The same pages/Layout render in two surfaces: the Telegram WebApp at
 * flat paths (`/`, `/wallet`, …) and the browser cabinet under `/app`
 * (`/app`, `/app/wallet`, …) — the site already owns `/`. Components
 * build links through `useAppPath()` so a single Layout works in both
 * without hardcoding either prefix. Default is `''` (Telegram), so the
 * in-app surface is unchanged unless a provider sets `/app`.
 */
export const AppBaseContext = createContext<string>('');

export function useAppBase(): string {
  return useContext(AppBaseContext);
}

export function joinAppPath(base: string, path: string): string {
  if (!path || path === '/') return base || '/';
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}

/** Returns a builder mapping an app-relative path (`/wallet`) to the
 * absolute path for the current surface (`/wallet` or `/app/wallet`). */
export function useAppPath(): (path: string) => string {
  const base = useAppBase();
  return (path: string) => joinAppPath(base, path);
}
